import { Injectable } from '@angular/core'
import { environment } from '../environments/environment'

// TODO Use a real logger
@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  debug(message: string, ...args: any[]): void {
    console.debug(message, ...args)
  }

  info(message: string, ...args: any[]): void {
    console.info(message, ...args)
  }

  warn(message: string, ...args: any[]): void {
    console.warn(message, ...args)
  }

  error(message: string, ...args: any[]): void {
    console.error(message, ...args)
  }

  sensitive(message: string) {
    if (!environment.production) {
      console.warn(`SENSITIVE: ${message}`)
    }
  }
}
